import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { RichText } from 'components/no-auth/common/promo-dangerously-html/RichText';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { CommonSection, TextComponent } from 'components/no-auth/common/sections/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const HelpArticleDeeplinkPage = (props) => {
    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" noTopPadding>
                <CommonSection>
                    <HeadingSection title={props.helpSectionName} dataTestId="help-article-h1-title" />
                    <TextComponent>
                        <RichText tag="div" dangerouslyHtml={props.helpSectionText} dataTestId="help-article-div-text" color="gray80" />
                    </TextComponent>
                </CommonSection>
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        helpSectionName: state.extra?.strapiApi?.Title,
        helpSectionText: state.extra?.strapiApi?.Content,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(HelpArticleDeeplinkPage));
